<template>
    <div class="login-page-wrapper contact-us-form" :class="{'bodyfont-unauth': !user}">
        <div class="over-lay"></div>
        <div class="bodyContent">
            <div v-if="!isForget" class="login-modal">
                <div>
                    <h2>Welcome to Tone</h2>
                </div>
                <div class="form">
                    <h3>Member Sign In</h3>
                    <form id="login_form" v-on:submit.prevent="onSubmit">
                        <div class="padding-minus">
                            <bs-input v-model="info.email"
                                      id="login_email"
                                      type="email"
                                      class="form-input"
                                      error="Email Address"
                                      placeholder="Email Address"
                                      required
                                      icon>
                            </bs-input>
                            <bs-input v-model="info.password"
                                      id="login_password"
                                      error="Password"
                                      type="password"
                                      class="form-input"
                                      placeholder="Password"
                                      required
                                      icon>
                            </bs-input>
                        </div>
                        <div class="text-center">
                            <button v-if="!spinner" class="btn formButton btn-transparent btn-block" id="login_button">
                                Sign In
                            </button>
                            <spinner v-if="spinner" v-model="spinner" size="lg" class="btn-spinner"></spinner>
                        </div>
                        <div class="text-center">
                            Forget your password ? <a href="javascript:" v-on:click="isForget = !isForget" class="forgotPassword" id="login_lnkforgotpassword">Click Here</a>
                        </div>
                    </form>
                    <!--<alert v-model="error.show" placement="top-right" duration="2000" type="danger" width="400px" dismissable>-->
                    <!--<span class="icon-info-circled alert-icon-float-left"></span>-->
                    <!--<strong>Error:</strong>-->
                    <!--<p id="login_errormsg">{{error.message}}</p>-->
                    <!--</alert>-->
                </div>
            </div>
            <div v-if="isForget" class="forget-password-modal">
                <div>
                    <h2 class="forgot-heading">
                        Forgot your password?
                    </h2>
                    <p>Enter your email address to reset your password. your may need
                    to check your spam folder to unblock<br>
                    no-reply@tonenetworks.com.</p>
                </div>
                <div class="form">
                    <form id="forgot_password_form" v-on:submit.prevent="onSubmitForgetRequest">
                        <bs-input v-model="forgetPassword.email"
                                  id="forgot_password_email"
                                  type="email"
                                  class="form-input"
                                  error="Email Address"
                                  placeholder="Email Address"
                                  required
                                  icon>
                        </bs-input>
                        <div class="text-center">
                            <button :disabled="spinner" class="btn formButton btn-transparent btn-block" id="forgot_password_proceed">
                                Submit
                                <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                            </button>
                        </div>
                        <div class="text-center">
                            <a href="javascript:" v-on:click="isForget = !isForget" class="forgotPassword" id="login_lnkbacktologin"><strong>Back to Sign In</strong></a>
                        </div>
                    </form>
                    <!--<h3 v-if="forgotPasswordSuccess">-->
                    <!--Forgot Password Request Sent! Check your email and follow the reset link-->
                    <!--</h3>-->
                    <!--<alert v-model="error.show" placement="top-right" duration="2000" type="danger" width="400px" dismissable>-->
                    <!--<span class="icon-info-circled alert-icon-float-left"></span>-->
                    <!--<strong>Error:</strong>-->
                    <!--<p id="forgotpassword_errormsg">{{error.message}}</p>-->
                    <!--</alert>-->
                </div>
            </div>
            <h2 class="boxed">Not a member</h2>
            <div class="padded">
                <p>If you're not yet a Member, please go to <strong>www.tonenetworks.com</strong> and select "Join" to create your account. </p>
                <p>For TONE Corporate Membership recipients who have not yet activated an account, please go to your customized activation link.</p>
            </div>
            <div class="boxpink">
                <h2 class="boxed">What you get</h2>
                <div class="list-group">
                    <li>Personalized bite-sized expert videos will inspire you and set a positive TONE to your day</li>
                    <li>Reserve your spot for TONE Live... exclusive live streaming events with our credentialed expert</li>
                    <li>Tune in to TONE Talks... our moderated discussions every Tuesday where we share advice within our community of women helping women!</li>
                    <li>And did we mention you will be helping out a charity every time you use the site?</li>
                    <li>Look out for TONE Teasers... customized emails with videos selected just for you!</li>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { input, spinner, alert } from 'vue-strap'
    import { mapGetters } from 'vuex'
    import MaskedInput from 'vue-masked-input'
    import $ from 'jquery'
    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'alert': alert,
            'masked-input': MaskedInput
        },
        name: 'login',
        data: function () {
            return {
                success: false,
                successMsg: '',
                info: {
                    email: '',
                    password: ''
                },
                forgetPassword: {
                    email: ''
                },
                isForget: false,
                spinner: false
            }
        },
        computed: {
            ...mapGetters([
                'error', 'user', 'getOriginalVideoCode'
            ])
        },
        methods: {
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            onSubmit () {
                var self = this
                if (self.info.email && self.info.password) {
                    self.spinnerToggle()
                    self.$store.dispatch('LOGIN', {user: self.info}).then(() => {
                        self.spinnerToggle()
                        if (!self.error.show) {
                            if ($(window).width() > 739) {
                            } else {
                                let self = this
                                var eventDesc
                                this.$store.dispatch('GETEVENTLIST').then(() => {
                                    if (this.getEventList) {
                                        let currentDate = this.returnEasternTime()
                                        let eMonth = currentDate.getMonth() + 1
                                        eMonth = eMonth >= 10 ? eMonth : `0${eMonth}`
                                        let eDate = currentDate.getDate() >= 10 ? currentDate.getDate() : `0${currentDate.getDate()}`
                                        let formattedDate = `${eMonth}/${eDate}/${currentDate.getFullYear()}`
                                        // Get Events on given Day
                                        let eventsOnDate = this.getEventList.filter(ev => {
                                            return ev.start_date.substr(0, 10) === formattedDate
                                        })
                                        // Get Events other than current Day
                                        let eventsNotOnDate = this.getEventList.filter(ev => {
                                            return new Date(ev.start_date.substr(0, 10)) > new Date(formattedDate)
                                        })
                                        if (eventsOnDate && eventsOnDate.length > 0) {
                                            if (this.isEventToday(eventsOnDate[0].end_date)) {
                                                let eventTime = new Date(eventsOnDate[0].start_date)
                                                let eventHrs = this.getHoursFormatted(eventTime)
                                                this.$store.dispatch('SETBANNEREVENT', eventsOnDate[0].eventId).then(() => {})
                                                if (eventsOnDate[0].type === '1') {
                                                    eventDesc = `Join us for TONE Live at ${eventHrs} ET`
                                                    this.eventDescription = eventsOnDate[0].unAuthBannerText
                                                } else {
                                                    eventDesc = `Join us for TONE Talks at ${eventHrs} ET`
                                                    this.eventDescription = eventsOnDate[0].unAuthBannerText
                                                }
                                                if (self.currentRoute.name === 'Hello') {
                                                    self.$swal({
                                                        background: '#44bda8',
                                                        title: '',
                                                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                        text: '',
                                                        type: null,
                                                        timer: 5000,
                                                        showConfirmButton: true,
                                                        showCloseButton: true,
                                                        showCancelButton: false,
                                                        confirmButtonColor: '#f0617d',
                                                        confirmButtonText:
                                                            'Find out more'
                                                    }).then(
                                                        function () {
                                                            self.JoinEventOrRedirect()
                                                        },
                                                        // handling the promise rejection
                                                        function (dismiss) {
                                                            if (dismiss === 'timer') {
                                                            }
                                                        }
                                                    )
                                                } else {

                                                }
                                            } else {
                                                // Display next event in queue
                                                if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                                                    // let formattedDate = this.getDateReference(eventsNotOnDate[0].start_date, 'event')
                                                    this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(() => {})
                                                    if (eventsNotOnDate[0].type === '1') {
                                                        this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                                        this.authEventDescription = eventsNotOnDate[0].authBannerText
                                                    } else {
                                                        this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                                        this.authEventDescription = eventsNotOnDate[0].authBannerText
                                                    }
                                                    eventDesc = this.eventDescription
                                                    if (self.currentRoute.name === 'Hello') {
                                                        self.$swal({
                                                            background: '#44bda8',
                                                            title: '',
                                                            html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                            text: '',
                                                            type: null,
                                                            timer: 5000,
                                                            showConfirmButton: true,
                                                            showCloseButton: true,
                                                            showCancelButton: false,
                                                            confirmButtonColor: '#f0617d',
                                                            confirmButtonText:
                                                                'Find out more'
                                                        }).then(
                                                            function () {
                                                                self.JoinEventOrRedirect()
                                                            },
                                                            // handling the promise rejection
                                                            function (dismiss) {
                                                                if (dismiss === 'timer') {
                                                                }
                                                            }
                                                        )
                                                    } else {

                                                    }
                                                }
                                            }
                                        } else {
                                            // Display other event in queue
                                            if (eventsNotOnDate && eventsNotOnDate.length > 0) {
//                                                let formattedDate = this.getDateReference(eventsNotOnDate[0].start_date, 'event')
                                                this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(() => {})
                                                if (eventsNotOnDate[0].type === '1') {
                                                    this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                                    this.authEventDescription = eventsNotOnDate[0].authBannerText
                                                } else {
                                                    this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                                    this.authEventDescription = eventsNotOnDate[0].authBannerText
                                                }
                                                eventDesc = this.eventDescription
                                                if (self.currentRoute.name === 'Hello') {
                                                    self.$swal({
                                                        background: '#44bda8',
                                                        title: '',
                                                        html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                        text: '',
                                                        type: null,
                                                        timer: 5000,
                                                        showConfirmButton: true,
                                                        showCloseButton: true,
                                                        showCancelButton: false,
                                                        confirmButtonColor: '#f0617d',
                                                        confirmButtonText:
                                                            'Find out more'
                                                    }).then(
                                                        function () {
                                                            self.JoinEventOrRedirect()
                                                        },
                                                        // handling the promise rejection
                                                        function (dismiss) {
                                                            if (dismiss === 'timer') {
                                                            }
                                                        }
                                                    )
                                                } else {

                                                }
                                            }
                                        }
                                    }
                                })
                            }
                        }
                        if (self.error.show && self.error.originalMessage !== 'aws.cognito.UserNotConfirmed') {
                            self.$swal({
                                title: self.error.message,
                                text: '',
                                type: 'error',
                                timer: 2000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(
                                function () {
                                },
                                // handling the promise rejection
                                function (dismiss) {
                                    if (dismiss === 'timer') {
                                    }
                                }
                            )
                        } else if (self.error.show && self.error.originalMessage === 'aws.cognito.UserNotConfirmed') {
                            self.$swal({
                                title: 'Validate Your Email Address',
                                text: 'We have already sent you a validation email. Do you want us to resend it?',
                                type: 'error',
                                showCancelButton: true,
                                confirmButtonText: 'Yes, Please',
                                cancelButtonText: 'Cancel',
                                confirmButtonClass: 'btn btn-success',
                                cancelButtonClass: 'btn btn-danger',
                                buttonsStyling: false
                            }).then(function (result) {
                                self.$store.dispatch('RESENDVALIDATIONCODE', self.info.email).then(() => {
                                    self.$swal({
                                        title: 'Check your mailbox for new validation email',
                                        text: '',
                                        type: 'success',
                                        timer: 3000,
                                        showCancelButton: false,
                                        showConfirmButton: false
                                    }).then(
                                        function () {
                                        },
                                        // handling the promise rejection
                                        function (dismiss) {
                                            if (dismiss === 'timer') {
                                            }
                                        }
                                    )
                                    self.cancelModal()
                                })
                            }, function (dismiss) {
                            })
                        } else {
                            self.cancelModal()
                            // self.spinnerToggle()
                        }
//                    if (self.user !== null) {
//                        console.info('login success')
//                        self.cancelModal()
//                    }
//                    self.spinnerToggle()
                    })
                }
            },
            onSubmitForgetRequest: function () {
                var self = this
                this.spinnerToggle()
                this.$store.dispatch('FORGOTPASSWORD', {user: this.forgetPassword}).then(() => {
                    this.spinnerToggle()
                    if (self.error.show) {
                        self.$swal({
                            title: self.error.message,
                            text: '',
                            type: 'error',
                            timer: 2000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                    } else {
                        self.$swal({
                            title: 'Forgot Password Request Sent! Check your email and follow the reset link',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        self.cancelModal()
                        // self.spinnerToggle()
                    }
//                if (!this.error.show) {
//                    this.forgotPasswordSuccess = true
//                    setTimeout(() => {
//                        this.forgotPasswordSuccess = false
//                        self.cancelModal()
//                    }, 3000)
//                }
                })
            }
        },
        mounted: function () {
            let originalVideoCode = this.getOriginalVideoCode
            if (originalVideoCode) {
                if (sessionStorage.getItem('redirectPath')) {
                    sessionStorage.removeItem('redirectPath')
                    sessionStorage.setItem('redirectPath', `/watch/${originalVideoCode}`)
                } else {
                    sessionStorage.setItem('redirectPath', `/watch/${originalVideoCode}`)
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#contactus_phonenumber {
    padding: 0 30px 0 15px;
    height: 60px;
    margin-bottom: 20px;
}
.contact-us-form p {
    font-size: 22px;
    font-family: sans-serif;
    letter-spacing: 0.5px;
    margin: 0 0 30px 0;
    font-weight: normal;
    line-height: 1;
    color: #777777;
}
.contact-us-form h2 {
    color: #f0617d;
    text-transform: capitalize;
    margin: 40px 0 15px 0;
    letter-spacing: 0.5px;
    font-family: sans-serif;
}
.bodyContent {
    padding: 0 20px;
}

.contact-us-form .login-modal h2 {
    color: #333;
    font-size: 25px;
    margin: 40px 0;
}

.form {
    border: 1px solid #ccc;
    padding: 15px;
}

h2.boxed {}

.login-page-wrapper.contact-us-form.bodyfont-unauth h2.boxed {
    font-size: 21px;
    text-align: left;
    padding: 15px;
    color: #fff;
    background: #f0617d;
}


.login-page-wrapper.contact-us-form.bodyfont-unauth .padded p {
    text-align: left;
    font-size: 18px;
    color:#000;
    padding: 0 15px;
}

.boxpink {
}
.list-group {
    border: 1px solid #ccc;
    padding: 15px;
    text-align: left;
    border-top: 0 none transparent;
}

.login-page-wrapper.contact-us-form.bodyfont-unauth .boxpink h2.boxed {
    margin: 0;
}

.list-group li {
    font-size: 18px;
    color: #000;
    margin: 0 0 15px;
}
.form h3 {
    text-align: left;
    margin: 0 0 15px;
    font-size: 21px;
}

.form {
    color: #000;
}

.form a {
    color: #000;
    text-decoration: underline;
    font-family:inherit !important;
}
</style>
<style>
    .contact-us-form .contact-form .form form .form-group textarea.form-control {
        max-height: 100px;
        min-height: 100px;
        min-width: 100%;
        max-width: 100%;
        width: 100% !important;
        height: 100px !important;
        resize: none;
    }
</style>



// WEBPACK FOOTER //
// JoinNowMobile.vue?035e3c1c